/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const recordWebVisitorV1BodySchema = z.object({
  visitorId: z.string(),
  fingerprint: z.string(),
  attributionPayload: z.string().nullable(),
});

export type IRecordWebVisitorV1Body = z.infer<typeof recordWebVisitorV1BodySchema>;
